import { dataTextShengSquare } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTextShengSquare = /*#__PURE__*/createIcon(dataTextShengSquare)
export default IconTextShengSquare
